import { useRef } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ClosingCta from '@/components/feature/ClosingCta';
import useScrollMotion from '@/hooks/useScrollMotion';
import { caseStudies } from '@/mocks/work';
import ProjectTile from './components/ProjectTile';

export default function WorkIndex() {
  const root = useRef<HTMLElement>(null);
  useScrollMotion(root);
  const [first, second, third, fourth] = caseStudies;

  return (
    <>
      <title>Work | FORM &amp; FEEL Event Production Portfolio</title>
      <meta name="description" content="Selected FORM & FEEL experiences: brand worlds, creative summits, private gatherings and product launches designed to bring people together." />
      <Header />
      <main ref={root} className="overflow-x-clip">
        <section aria-label="Work" className="bg-foreground-950 text-background-50">
          <div className="flex min-h-[78svh] flex-col justify-end px-4 md:px-6 pt-32 pb-12 md:pb-16">
            <p className="font-label text-[11px] uppercase tracking-[0.18em] text-background-200" data-reveal="up">Selected experiences / {caseStudies.length.toString().padStart(2, '0')}</p>
            <h1 className="mt-6 font-extrabold uppercase tracking-[-0.065em] leading-[0.84] text-[clamp(3.4rem,13vw,14rem)]" data-reveal="lines">
              <span className="line-mask"><span className="line-inner">Work that</span></span>
              <span className="line-mask"><span className="line-inner text-primary-300">stays.</span></span>
            </h1>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-6 border-t border-background-50/15 pt-6">
              <p className="md:col-span-5 md:col-start-8 text-sm md:text-base leading-relaxed text-background-100 max-w-[420px]" data-reveal="up">
                Experiences built to bring people together and leave something behind.
              </p>
            </div>
          </div>
        </section>

        <section aria-label="Project gallery" className="bg-background-50 px-4 md:px-6 py-20 md:py-28">
          <ProjectTile project={first} large reveal="clip-center" frameClass="h-[64vw] md:h-[48vw] max-h-[820px] min-h-[340px]" />

          <div className="mt-4 md:mt-6 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
            <ProjectTile project={second} className="md:col-span-8" reveal="clip-left" frameClass="h-[70vw] md:h-[34vw] max-h-[620px] min-h-[320px]" />
            <ProjectTile project={third} className="md:col-span-4" compact reveal="clip-right" frameClass="h-[70vw] md:h-[34vw] max-h-[620px] min-h-[320px]" />
          </div>

          <div className="mt-4 md:mt-6">
            <ProjectTile project={fourth} large reveal="clip-center" frameClass="h-[64vw] md:h-[48vw] max-h-[820px] min-h-[340px]" />
          </div>

          <p className="mt-14 font-label text-[10px] uppercase tracking-[0.16em] text-secondary-600">Illustrative portfolio concepts</p>
        </section>

        <ClosingCta eyebrow="What&apos;s next" lines={['Your idea', 'could be next.']} />
      </main>
      <Footer />
    </>
  );
}